<template>
  <div id="campaigns">
    <div class="container-fluid">
      <div class="row">
        <div
          role="main"
          class="col d-block pt-2"
        >
          <section class="pt-3">
            <div class="section-title">
              Analytics
            </div>
            <div class="row d-block">
              <div class="col">
                <div class="row mt-3">
                  <div class="col-lg-12">
                    <form
                      @submit.prevent.stop="runQuery"
                    >
                      <div class="card">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-xl col-lg-6 col-md-6 col-sm-12 form-group">
                              <label
                                class="label label-default"
                                for="templateName"
                              >
                                Query
                              </label>

                              <textarea
                                v-model="query"
                                rows="6"
                                type="text"
                                class="form-control"
                                id="templateName"
                                name="templateName"
                                placeholder="Select ... "
                                required
                              />
                              <button
                                @click.stop.prevent="queryRegionsInLastYear"
                                class="btn"
                              >
                                <i class="jam jam-arrow-right" /> last year by region
                              </button>
                              <button
                                @click.stop.prevent="queryProvincesInLastYear"
                                class="btn"
                              >
                                <i class="jam jam-arrow-right" /> last year by province
                              </button>
                              <button
                                @click.stop.prevent="queryPriceStatsInLastYear"
                                class="btn"
                              >
                                <i class="jam jam-arrow-right" /> sales stats, last year (no dups)
                              </button>
                              <button
                                @click.stop.prevent="queryAvgPricePerRegionInLastYear"
                                class="btn"
                              >
                                <i class="jam jam-arrow-right" /> sales avg price/m2, last year, by region (no dups)
                              </button>
                              <button
                                @click.stop.prevent="queryMedianPricePerRegionInLastYear"
                                class="btn"
                              >
                                <i class="jam jam-arrow-right" /> sales median price/m2, last year, by region (no dups)
                              </button>
                              <button
                                @click.stop.prevent="queryMedianPricePerRegionFullMonthInLastYear"
                                class="btn"
                              >
                                <i class="jam jam-arrow-right" /> sales median price/m2 by full month by region (no dups)
                              </button>
                              <button
                                @click.stop.prevent="queryTotalPerRegionFullMonthInLastYear"
                                class="btn"
                              >
                                <i class="jam jam-arrow-right" /> sales count by region by full month by region (no dups)
                              </button>
                              <button
                                @click.stop.prevent="queryTotalFullMonthInLastYear"
                                class="btn"
                              >
                                <i class="jam jam-arrow-right" /> sales count by full month (no dups)
                              </button>
                              <button
                                @click.stop.prevent="queryTopMunicipalitiesByMedianPrice"
                                class="btn"
                              >
                                <i class="jam jam-arrow-right" /> top municipalities by median price, full month, no dups
                              </button>
                              <button
                                @click.stop.prevent="queryMailshotExample"
                                class="btn"
                              >
                                <i class="jam jam-arrow-right" /> mailshot example query
                              </button>
                              <hr>
                              <button
                                @click.stop.prevent="queryAlertsLastWeek"
                                class="btn"
                              >
                                <i class="jam jam-arrow-right" /> last week ts-alerts
                              </button>
                              <button
                                @click.stop.prevent="queryPropertyAlertsLastWeek(0, 800000)"
                                class="btn"
                              >
                                <i class="jam jam-arrow-right" /> last week propertyalerts (&lt; 800k)
                              </button>
                              <button
                                @click.stop.prevent="queryPropertyAlertsLastWeek(800000, 100000000)"
                                class="btn"
                              >
                                <i class="jam jam-arrow-right" /> last week propertyalerts (&gt; 800k)
                              </button>
                              <button
                                @click.stop.prevent="queryPropertyAlertsByTag()"
                                class="btn"
                              >
                                <i class="jam jam-arrow-right" /> propertyalerts by tag, last 3 months
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="card-footer">
                          <button
                            type="submit"
                            class="btn btn-primary float-right"
                          >
                            <i class="jam jam-search" /> Run
                          </button>
                        </div>
                      </div>
                    </form>

                    <div class="row mt-3">
                      <div class="col-12">
                        <button
                          v-if="rows.length > 0"
                          @click.stop.prevent="exportToCSV"
                          class="btn btn-secondary float-right"
                        >
                          <i class="jam jam-download" /> Download (CSV)
                        </button>
                        <div class="table mt-4">
                          <table
                            id="campaignsCampaigns"
                            class="w-100 pb-4 pt-4 responsive white-space table-striped"
                          >
                            <thead v-if="rows.length > 0">
                              <tr>
                                <th v-for="cell in rows[0]">
                                  {{ cell }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(row, index) in rows"
                                v-if="index > 0"
                              >
                                <td v-for="cell in row">
                                  {{ cell }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div class="clearfix" />
        </div>
        <div class="clearfix" />
      </div>
    </div>
  </div>
</template>
<script>
import http from '../../../http';
import notify from '../../../notifications';

const zeroPad = ( num, places ) => String( num ).padStart( places, '0' );

var getLastYearDateKeys = function() {
    let d = new Date();
    d.setDate( 1 );
    d.setMonth( d.getMonth() - 12 );
    let dateKeys = [];

    while ( d < ( new Date() ) ) {
        dateKeys.push( `${d.getFullYear()}/${zeroPad( d.getMonth() + 1, 2 )}/${zeroPad( d.getDate(), 2 )}` );
        d.setMonth( d.getMonth() + 1 );
    }
    return dateKeys;
};

export default {
    data() {
        return {
            query: '',
            queryId: null,
            nextToken: null,
            rows: []
        };
    },
    methods: {
        async queryPriceStatsInLastYear() {
            let dateKeys = getLastYearDateKeys();

            this.query = `
      with t as (
        select map_agg(d, avgperm2) as m, map_agg(d, total) as mc, map_agg(d, avgprice) as ma, map_agg(d, medianperm2) as mm, map_agg(d, median) as mp
        from (
            select substr(storeddatehour, 1, 10) as d, avg(normalizedpriceineuro/build) as avgperm2, count(*) as total, avg(normalizedpriceineuro) as avgprice, approx_percentile(normalizedpriceineuro/build, 0.5) as medianperm2, approx_percentile(normalizedpriceineuro, 0.5) as median
            from property_snapshot
            where 
              (${dateKeys.map( d => `storeddatehour like '${d}/%'` ).join( ' or ' )})
              and type.id in (1, 2, 3, 4, 5, 6, 7, 8, 15, 17, 19, 20, 22)
              and (duplicate.isaduplicate is null or duplicate.isaduplicate = false)
              and offertype.name = 'for-sale'
              and build > 20
              and normalizedpriceineuro > 0
            group by substr(storeddatehour, 1, 10)
        )
      )
      select 'average price per m2' as category, ${dateKeys.map( d => `m['${d}'] as "${d}"` ).join( ', ' )} from t
      union all
      select 'count of properties' as category, ${dateKeys.map( d => `mc['${d}'] as "${d}"` ).join( ', ' )} from t
      union all
      select 'average price' as category, ${dateKeys.map( d => `ma['${d}'] as "${d}"` ).join( ', ' )} from t
      union all
      select 'median price per m2' as category, ${dateKeys.map( d => `mm['${d}'] as "${d}"` ).join( ', ' )} from t
      union all
      select 'median price' as category, ${dateKeys.map( d => `mp['${d}'] as "${d}"` ).join( ', ' )} from t
      `;
        },
        async queryAvgPricePerRegionInLastYear() {
            let dateKeys = getLastYearDateKeys();

            this.query = `
      select r as regionName, ${dateKeys.map( d => `m['${d}'] as "${d}"` ).join( ', ' )}
      from (
          select r, map_agg(d, total) as m
          from (
              select coalesce(region.labels.default, region.labels.en, region.labels.es) as r, substr(storeddatehour, 1, 10) as d, avg(normalizedpriceineuro/build) as total 
              from property_snapshot
              where (${dateKeys.map( d => `storeddatehour like '${d}/%'` ).join( ' or ' )})
                and (duplicate.isaduplicate is null or duplicate.isaduplicate = false)
                and offertype.name = 'for-sale'
                and build > 0
                and normalizedpriceineuro > 0
              group by coalesce(region.labels.default, region.labels.en, region.labels.es), substr(storeddatehour, 1, 10)
          )
          group by r
      )
      order by regionName
      `;
        },
        async queryMedianPricePerRegionInLastYear() {
            let dateKeys = getLastYearDateKeys();

            this.query = `
      select r as regionName, ${dateKeys.map( d => `m['${d}'] as "${d}"` ).join( ', ' )}
      from (
          select r, map_agg(d, total) as m
          from (
              select coalesce(region.labels.default, region.labels.en, region.labels.es) as r, substr(storeddatehour, 1, 10) as d, approx_percentile(normalizedpriceineuro/build, 0.5) as total 
              from property_snapshot
              where (${dateKeys.map( d => `storeddatehour like '${d}/%'` ).join( ' or ' )})
                and (duplicate.isaduplicate is null or duplicate.isaduplicate = false)
                and offertype.name = 'for-sale'
                and build > 0
                and normalizedpriceineuro > 0
              group by coalesce(region.labels.default, region.labels.en, region.labels.es), substr(storeddatehour, 1, 10)
          )
          group by r
      )
      order by regionName
      `;
        },
        async queryMedianPricePerRegionFullMonthInLastYear() {
            let dateKeys = getLastYearDateKeys();

            this.query = `
      select r as regionName, ${dateKeys.map( d => `m['${d.slice( 0, -3 )}'] as "${d.slice( 0, -3 )}"` ).join( ', ' )}
      from (
          select r, map_agg(d, total) as m
          from (
              select coalesce(region.labels.default, region.labels.en, region.labels.es) as r, substr(storeddatehour, 1, 7) as d, approx_percentile(normalizedpriceineuro/build, 0.5) as total 
              from property_snapshot
              where (${dateKeys.map( d => `storeddatehour like '${d.slice( 0, -3 )}/%'` ).join( ' or ' )})
                and (duplicate.isaduplicate is null or duplicate.isaduplicate = false)
                and offertype.name = 'for-sale'
                and build > 0
                and normalizedpriceineuro > 0
              group by coalesce(region.labels.default, region.labels.en, region.labels.es), substr(storeddatehour, 1, 7)
          )
          group by r
      )
      order by regionName
      `;
        },
        async queryTotalPerRegionFullMonthInLastYear() {
            let dateKeys = getLastYearDateKeys();

            this.query = `
      select r as regionName, ${dateKeys.map( d => `m['${d.slice( 0, -3 )}'] as "${d.slice( 0, -3 )}"` ).join( ', ' )}
      from (
          select r, map_agg(d, total) as m
          from (
              select coalesce(region.labels.default, region.labels.en, region.labels.es) as r, substr(storeddatehour, 1, 7) as d, count(*) as total 
              from property_snapshot
              where (${dateKeys.map( d => `storeddatehour like '${d.slice( 0, -3 )}/%'` ).join( ' or ' )})
                and (duplicate.isaduplicate is null or duplicate.isaduplicate = false)
                and offertype.name = 'for-sale'
                and build > 0
                and normalizedpriceineuro > 0
              group by coalesce(region.labels.default, region.labels.en, region.labels.es), substr(storeddatehour, 1, 7)
          )
          group by r
      )
      order by regionName
      `;
        },
        async queryTotalFullMonthInLastYear() {
            let dateKeys = getLastYearDateKeys();

            this.query = `
      with t as (
        select map_agg(d, total) as mc, map_agg(d, medianperm2) as mm, map_agg(d, median) as mp
        from (
            select substr(storeddatehour, 1, 7) as d, count(*) as total, approx_percentile(normalizedpriceineuro/build, 0.5) as medianperm2, approx_percentile(normalizedpriceineuro, 0.5) as median
            from property_snapshot
            where 
              (${dateKeys.map( d => `storeddatehour like '${d.slice( 0, -3 )}/%'` ).join( ' or ' )})
              and type.id in (1, 2, 3, 4, 5, 6, 7, 8, 15, 17, 19, 20, 22)
              and (duplicate.isaduplicate is null or duplicate.isaduplicate = false)
              and offertype.name = 'for-sale'
              and build > 20
              and normalizedpriceineuro > 0
            group by substr(storeddatehour, 1, 7)
        )
      )
      select 'count of properties' as category, ${dateKeys.map( d => `mc['${d.slice( 0, -3 )}'] as "${d.slice( 0, -3 )}"` ).join( ', ' )} from t
      union all
      select 'median price per m2' as category, ${dateKeys.map( d => `mm['${d.slice( 0, -3 )}'] as "${d.slice( 0, -3 )}"` ).join( ', ' )} from t
      union all
      select 'median price' as category, ${dateKeys.map( d => `mp['${d.slice( 0, -3 )}'] as "${d.slice( 0, -3 )}"` ).join( ', ' )} from t
      `;
        },
        async queryRegionsInLastYear() {
            let dateKeys = getLastYearDateKeys();

            this.query = `
      select r as regionName, ${dateKeys.map( d => `m['${d}'] as "${d}"` ).join( ', ' )}
      from (
          select r, map_agg(d, total) as m
          from (
              select coalesce(region.labels.default, region.labels.en, region.labels.es) as r, substr(storeddatehour, 1, 10) as d, count(*) as total 
              from property_snapshot
              where (${dateKeys.map( d => `storeddatehour like '${d}/%'` ).join( ' or ' )})
              group by coalesce(region.labels.default, region.labels.en, region.labels.es), substr(storeddatehour, 1, 10)
          )
          group by r
      )
      order by regionName
      `;
        },
        async queryProvincesInLastYear() {
            let dateKeys = getLastYearDateKeys();

            this.query = `
      select p as provinceName, ${dateKeys.map( d => `m['${d}'] as "${d}"` ).join( ', ' )}
      from (
          select p, map_agg(d, total) as m
          from (
              select coalesce(province.labels.default, province.labels.en, province.labels.es) as p, substr(storeddatehour, 1, 10) as d, count(*) as total 
              from property_snapshot
              where (${dateKeys.map( d => `storeddatehour like '${d}/%'` ).join( ' or ' )})
              group by coalesce(province.labels.default, province.labels.en, province.labels.es), substr(storeddatehour, 1, 10)
          )
          group by p
      )
      order by provinceName
      `;
        },
        async queryTopMunicipalitiesByMedianPrice() {
            this.query = `
        select inn.municipality, m.Name, inn.median_price, inn.total
        from (
            select location.municipality[1] as "municipality", approx_percentile(normalizedpriceineuro, 0.5) as median_price, count(*) as total
            from property_snapshot
            where storeddatehour like '${( new Date() ).getFullYear()}/${zeroPad( ( new Date() ).getMonth() + 1, 2 ) }/%'
              and (duplicate.isaduplicate is null or duplicate.isaduplicate = false)
              and offertype.name = 'for-sale'
              and build > 0
              and normalizedpriceineuro > 0
            group by location.municipality[1]
        ) as inn
        left join municipalities as m on inn.municipality = m.id
        where inn.total > 1000
        order by inn.median_price desc
      `;
        },
        async queryMailshotExample() {
            this.query = `
              with cte as (
                  select 
                      e.eventType,
                      array_join(flatten(array[ e.mail.tags['twc-tag-0'],e.mail.tags['twc-tag-1'],e.mail.tags['twc-tag-2'],e.mail.tags['twc-tag-3']]), ';') AS tags
                  from email_events e
                  where storeddate >= '2023/06/13'
              )
              select 
                      cte.eventType as "Event",
                      cte.tags as "Tags",
                      count(*)
              from cte
              where cte.tags like '%less-150k-properties_20230613%'
              group by cte.eventType, cte.tags
              order by cte.tags, cte.eventType
              `;
        },
        async queryAlertsLastWeek() {
            // get date in 'yyyy/MM/dd' for last monday
            let from = new Date();
            from.setDate( from.getDate() - ( from.getDay() + 6 ) % 7 - 7 );
            let to = new Date();
            to.setDate( to.getDate() - ( to.getDay() + 6 ) % 7 );

            let fromString = `${from.getFullYear()}-${zeroPad( from.getMonth() + 1, 2 )}-${zeroPad( from.getDate(), 2 )}`;
            let toString = `${to.getFullYear()}-${zeroPad( to.getMonth() + 1, 2 )}-${zeroPad( to.getDate(), 2 )}`;

            from.setDate( from.getDate() - 3 );
            to.setDate( to.getDate() + 3 );

            let fromWithBoundsString = `${from.getFullYear()}/${zeroPad( from.getMonth() + 1, 2 )}/${zeroPad( from.getDate(), 2 )}`;
            let toWithBoundsString = `${to.getFullYear()}/${zeroPad( to.getMonth() + 1, 2 )}/${zeroPad( to.getDate(), 2 )}`;

            this.query = `
        with cte as (
          select 
              e.mail.messageId,
              date_format(from_iso8601_timestamp(e.mail.timestamp), '%Y-%m-%d %H:%i:%s') as time,
              coalesce(regexp_extract(d.destination_email, '[^<]+<([^>]+)>', 1), d.destination_email) as email,
              coalesce(regexp_extract(e.mail.source, '[^<]+<([^>]+)>', 1), e.mail.source) as Sender,
              e.mail.commonHeaders.subject,
              e.eventType,
              array_join(flatten(array[ e.mail.tags['twc-tag-0'],e.mail.tags['twc-tag-1'],e.mail.tags['twc-tag-2'],e.mail.tags['twc-tag-3']]), ';') AS tags,
              e.mail.tags['twc-subaccount'][1] as subaccount,
              0 as clicks,
              coalesce(e.bounce.bouncedRecipients[1].diagnosticCode, '') as bounceDiagnosticCode,
              row_number() over (partition by e.mail.messageid order by coalesce(
            e.bounce.timestamp, 
            e.delivery.timestamp, 
            e.open.timestamp, 
            e.subscription.timestamp, 
            e.deliverydelay.timestamp, 
            e.complaint.timestamp, 
            e.mail.timestamp
            ) desc) as rn
          from email_events e
          cross join unnest(e.mail.destination) d(destination_email)
          where storeddate >= '${fromWithBoundsString}' and storeddate < '${toWithBoundsString}' and e.mail.tags['twc-subaccount'][1] in ('propertyalerts')
            and e.mail.timestamp >= '${fromString}' and e.mail.timestamp < '${toString}'
      )
      select 
              cte.time as Date,
              cte.email as "Email Address",
              cte.Sender,
              cte.subject as "Subject",
              cte.tags as "Tags",
              cte.subaccount as "Subaccount",
              case 
                  when sum(case when rn = 1 and cte.eventType in ('Bounce', 'Complaint', 'Reject') then 1 else 0 end) > 0 then 'bounced'
                  else 'sent'
              end as "Status",
              count(case when cte.eventType = 'Open' then 1 end) as "Opens",
              cte.clicks as "Clicks",
              cte.bounceDiagnosticCode as "Bounce Detail"
      from cte
      group by 
              cte.messageId,
              cte.time,
              cte.email,
              cte.Sender,
              cte.subject,
              cte.tags,
              cte.subaccount,
              cte.clicks,
              cte.bounceDiagnosticCode
      `;
        },
        async queryPropertyAlertsByTag() {
            // get date in 'yyyy/MM/dd' for last 3 months
            const currentDate = new Date();
            // Calculate the date 3 months ago
            const fromDate = new Date( currentDate.setMonth( currentDate.getMonth() - 3 ) );
            // Format the date to 'yyyy/MM/dd'
            const formattedFromDate = fromDate.toISOString().split( 'T' )[ 0 ].replace( /-/g, '/' );

            this.query = `
              SELECT
                tag_value,
                SUM(CASE WHEN eventtype = 'Send' THEN event_count ELSE 0 END) AS sends,
                SUM(CASE WHEN eventtype = 'Delivery' THEN event_count ELSE 0 END) AS deliveries,
                SUM(CASE WHEN eventtype = 'Open' THEN event_count ELSE 0 END) AS opens,
                SUM(CASE WHEN eventtype = 'Bounce' THEN event_count ELSE 0 END) AS bounces,
                SUM(CASE WHEN eventtype = 'Complaint' THEN event_count ELSE 0 END) AS complaints,
                SUM(CASE WHEN eventtype = 'DeliveryDelay' THEN event_count ELSE 0 END) AS delivery_delays,
                SUM(CASE WHEN eventtype = 'Reject' THEN event_count ELSE 0 END) AS rejects,
                SUM(CASE WHEN eventtype = 'Click' THEN event_count ELSE 0 END) AS clicks
              FROM
                (
                  SELECT
                    tag_key,
                    tag_value,
                    eventtype,
                    COUNT(*) AS event_count
                  FROM
                    (
                      SELECT *
                      FROM email_events
                      WHERE
                        storeddate >= '${formattedFromDate}'
                        AND contains(
                          flatten(map_values(mail.tags)),
                          'propertyalerts'
                        )
                    ) AS e
                  CROSS JOIN
                    UNNEST(e.mail.tags) AS t(tag_key, tag_values)
                  CROSS JOIN
                    UNNEST(tag_values) AS t2(tag_value)
                  GROUP BY
                    tag_key,
                    tag_value,
                    eventtype
                ) AS data
              WHERE tag_key like 'twc-tag-%'
              GROUP BY
                tag_value
              ORDER BY
                tag_value;
            `;
        },
        async queryPropertyAlertsLastWeek( skip, take ) {
            // get date in 'yyyy/MM/dd' for last monday
            let from = new Date();
            from.setDate( from.getDate() - ( from.getDay() + 6 ) % 7 - 7 );
            let to = new Date();
            to.setDate( to.getDate() - ( to.getDay() + 6 ) % 7 );

            let fromString = `${from.getFullYear()}-${zeroPad( from.getMonth() + 1, 2 )}-${zeroPad( from.getDate(), 2 )}`;
            let toString = `${to.getFullYear()}-${zeroPad( to.getMonth() + 1, 2 )}-${zeroPad( to.getDate(), 2 )}`;

            from.setDate( from.getDate() - 3 );
            to.setDate( to.getDate() + 3 );

            let fromWithBoundsString = `${from.getFullYear()}/${zeroPad( from.getMonth() + 1, 2 )}/${zeroPad( from.getDate(), 2 )}`;
            let toWithBoundsString = `${to.getFullYear()}/${zeroPad( to.getMonth() + 1, 2 )}/${zeroPad( to.getDate(), 2 )}`;

            this.query = `
        with cte as (
          select 
              e.mail.messageId,
              date_format(from_iso8601_timestamp(e.mail.timestamp), '%Y-%m-%d %H:%i:%s') as time,
              coalesce(regexp_extract(d.destination_email, '[^<]+<([^>]+)>', 1), d.destination_email) as email,
              coalesce(regexp_extract(e.mail.source, '[^<]+<([^>]+)>', 1), e.mail.source) as Sender,
              e.mail.commonHeaders.subject,
              e.eventType,
              array_join(flatten(array[ e.mail.tags['twc-tag-0'],e.mail.tags['twc-tag-1'],e.mail.tags['twc-tag-2'],e.mail.tags['twc-tag-3']]), ';') AS tags,
              e.mail.tags['twc-subaccount'][1] as subaccount,
              0 as clicks,
              coalesce(e.bounce.bouncedRecipients[1].diagnosticCode, '') as bounceDiagnosticCode,
              row_number() over (partition by e.mail.messageid order by coalesce(
            e.bounce.timestamp, 
            e.delivery.timestamp, 
            e.open.timestamp, 
            e.subscription.timestamp, 
            e.deliverydelay.timestamp, 
            e.complaint.timestamp, 
            e.mail.timestamp
            ) desc) as rn
          from email_events e
          cross join unnest(e.mail.destination) d(destination_email)
          where storeddate >= '${fromWithBoundsString}' and storeddate < '${toWithBoundsString}' and e.mail.tags['twc-subaccount'][1] in ('propertyalerts')
            and e.mail.timestamp >= '${fromString}' and e.mail.timestamp < '${toString}'
      )
      select 
              cte.time as Date,
              cte.email as "Email Address",
              cte.Sender,
              cte.subject as "Subject",
              cte.tags as "Tags",
              cte.subaccount as "Subaccount",
              case 
                  when sum(case when rn = 1 and cte.eventType in ('Bounce', 'Complaint', 'Reject') then 1 else 0 end) > 0 then 'bounced'
                  else 'sent'
              end as "Status",
              count(case when cte.eventType = 'Open' then 1 end) as "Opens",
              cte.clicks as "Clicks",
              cte.bounceDiagnosticCode as "Bounce Detail"
      from cte
      group by 
              cte.messageId,
              cte.time,
              cte.email,
              cte.Sender,
              cte.subject,
              cte.tags,
              cte.subaccount,
              cte.clicks,
              cte.bounceDiagnosticCode
      order by cte.time, cte.messageId
      offset ${skip} limit ${take}
      `;
        },
        async exportToCSV() {
            this.$store.dispatch( 'appLoading', true );
            let result = await http.get( `/analytics/query/${this.queryId}/csv` );

            if ( result.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to run query'
                } );
                return;
            }

            var j = await result.json();

            const link = document.createElement( 'a' );
            link.href = j.url;
            link.setAttribute( 'download', 'results.csv' ); // or any other extension
            document.body.appendChild( link );
            link.click();
            this.$store.dispatch( 'appLoading', false );
        },
        async runQuery() {
            this.$store.dispatch( 'appLoading', true );

            this.queryId = null;
            this.nextToken = null;
            this.rows = [];

            if ( this.query.length == 0 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Please fill up the query',
                    title: 'Failed to run query'
                } );
                return;
            }

            let response = await http.post( '/analytics/query/run', { query: this.query } );

            if ( response.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to run query'
                } );
                return;
            }

            let data = await response.json();
            this.queryId = data.queryId;

            const sleep = ms => new Promise( res => setTimeout( res, ms ) );

            let status = '';

            for ( let i = 0; i < 60; i++ ) {
                let statusResponse = await http.get( `/analytics/query/${this.queryId}/status` );

                if ( statusResponse.status !== 200 ) {
                    this.$store.dispatch( 'appLoading', false );
                    notify( {
                        type: 'error',
                        text: 'Something went wrong',
                        title: 'Failed to run query'
                    } );
                    return;
                }

                status = ( await statusResponse.json() ).status;

                if ( status == 'RUNNING' || status === 'QUEUED' ) {
                    await sleep( 2000 );
                    continue;
                }

                break;
            }

            if ( status !== 'SUCCEEDED' ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to run query'
                } );
                return;
            }

            let rowResults = await http.get( `/analytics/query/${this.queryId}/results` );

            if ( rowResults.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to run query'
                } );
                return;
            }

            let result = await rowResults.json();

            this.rows = result.rows;
            this.nextToken = result.nextToken;

            this.$store.dispatch( 'appLoading', false );
        }
    },
    components: {}
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/analytics/index.vue